<script lang="ts">
  import { onMount } from 'svelte';

  export let suitability: string[] = [];
  export let showFullText: boolean = false;
  export let isLiked: boolean = false;
  export let isDisliked: boolean = false;

  $: badges = [
    ...(isLiked ? ['Liked'] : []),
    ...(isDisliked ? ['Disliked'] : []),
    ...suitability,
  ]

  // @ts-ignore
  const jq = window.jQuery;

  // Group definitions
  const RECOMMENDATION = ['Out of Reach','Not Recommended','Optimal'];
  const PRODUCTIVITY = ['Very Productive','Productive','Good','Fair','Unproductive'];
  const PRODUCTIVITY_UPPER = ['Very Productive','Productive','Good'];
  const PRODUCTIVITY_LOWER = ['Fair','Unproductive'];
  const FOCUS = ['Optimal Focus','Near Focus','Out of Focus'];
  const CHALLENGE = ['Group Challenging','Very Challenging','Challenging','Group Achievable','Achievable'];
  const CHALLENGE_UPPER = ['Group Challenging','Very Challenging'];
  const CHALLENGE_LOWER = ['Challenging','Group Achievable','Achievable'];
  const SPECIAL = ['Breakthrough'];

  type BadgeStyle = { bg: string; text: string };
  const suitabilityColours: Record<string, BadgeStyle> = {
    // Recommendation
    'Out of Reach':    { bg: '#F9B9B9', text: '#7F1D1D' },
    'Not Recommended': { bg: '#F9B9B9', text: '#7F1D1D' },
    'No XSS/Power Data': { bg: '#D5DDE4', text: '#334155' },
    // Productivity
    'Very Productive': { bg: '#7FEADD', text: '#065F46' },
    'Productive':      { bg: '#8FF5B8', text: '#064E3B' },
    'Good':            { bg: '#d3f5b8', text: '#065F46' },
    'Fair':            { bg: '#FFE08F', text: '#92400E' },
    'Unproductive':    { bg: '#F7B3B3', text: '#7F1D1D' },
    // Focus
    'Optimal Focus':   { bg: '#c6b6fc', text: '#4f1dd8' },
    'Near Focus':      { bg: '#BEEBFF', text: '#1D4ED8' },
    'Out of Focus':    { bg: '#D5DDE4', text: '#334155' },
    // Challenge
    'Group Challenging': { bg: '#FFB384', text: '#7C2D12' },
    'Very Challenging':  { bg: '#FFC291', text: '#7C2D12' },
    'Challenging':       { bg: '#FFD994', text: '#92400E' },
    'Group Achievable':  { bg: '#98E8D4', text: '#064E3B' },
    'Achievable':        { bg: '#A5EED9', text: '#064E3B' },
    // Special
    'Breakthrough':    { bg: '#FFD97D', text: '#7C3E07' },
    // Fit to a forecast day
    'Duration':        { bg: '#E2E8F0', text: '#334155' },
    // Like/Dislike
    'Liked':           { bg: '#D1FAE5', text: '#065F46' },
    'Disliked':        { bg: '#FECACA', text: '#7F1D1D' },
  };

  function groupIcon(badge: string): string {
    if (RECOMMENDATION.includes(badge)) return 'fa-circle-xmark';
    if (badge === 'No XSS/Power Data') return 'fa-bolt-slash';
    if (PRODUCTIVITY_UPPER.includes(badge)) return 'fa-arrow-trend-up';
    if (PRODUCTIVITY_LOWER.includes(badge)) return 'fa-arrow-trend-down';
    if (FOCUS.includes(badge)) return 'fa-bullseye';
    if (CHALLENGE_UPPER.includes(badge)) return 'fa-fire';
    if (CHALLENGE_LOWER.includes(badge)) return 'fa-mountain';
    if (badge === 'Breakthrough') return 'fa-star';
    if (badge === 'Duration') return 'fa-clock';
    if (badge === 'Liked') return 'fa-thumbs-up';
    if (badge === 'Disliked') return 'fa-thumbs-down';
    return 'fa-circle-question';
  }

  function suitabilityToLabel(s: string) {
    if (['Good', 'Fair'].includes(s)) return s + ' Productivity';
    if (s === 'Duration') return 'Longer than the time available';
    return s;
  }

  onMount(() => {
    jq('[data-toggle=tooltip]').tooltip({container: '#shadcn-ui-dialog-target'});
  });

</script>

<div class="flex flex-wrap gap-1">
  {#each badges as badge}
    {#if suitabilityColours[badge]}
      {#key badge}
        <span
          data-toggle='tooltip'
          class="inline-flex gap-1 items-center justify-center rounded-full px-2 h-6 text-[11px] font-medium select-none shadow-sm"
          style="background:{suitabilityColours[badge].bg};color:{suitabilityColours[badge].text};"
          aria-label={suitabilityToLabel(badge)}
          title={suitabilityToLabel(badge)}
        >
          <i class={`fa-solid ${groupIcon(badge)} text-xs`} aria-hidden="true"></i>
          {#if showFullText}
            {suitabilityToLabel(badge)}
          {/if}
        </span>
      {/key}
    {:else}
      <span
        class="inline-flex items-center justify-center rounded-full px-2 h-6 text-[11px] font-medium select-none bg-gray-100 text-gray-600"
        aria-label={badge}
        title={badge}
      >
        <i class="fa-regular fa-circle-question text-[12px]"></i>
      </span>
    {/if}
  {/each}
</div>